module.exports = __webpack_public_path__ + "static/img/row7.42e98c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/mobile/row7.png
// module id = FBz+
// module chunks = 12